import React, { Component } from 'react';
import { useState, useEffect } from 'react';
import { sendGoogleAnalytics } from "./common/BaseUtil"
import { useLocation } from "react-router-dom";

export function CpIntro() {
    const location = useLocation();

    useEffect(() => {
        sendGoogleAnalytics(location.pathname)
    }, []);

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>회사</span></li>
                        </ol>
                        <div class="card">
                            <div class="card-body">
                                <h4 class="card-title" style={{fontFamily: 'Nanum Gothic', fontWeight: 'bold'}}>사람과 사람을 이어주는 지쿠소프트</h4>
                                <p class="card-text" style={{fontWeight: 'bold', marginTop: '20px'}}>비젼</p>
                                <p class="card-text">
                                    우리의 사명은 독일에서 일자리를 찾는 한국 교민들과 인재를 찾는 기업 간의 연결을 돕는 것입니다.<br/>
                                    <br/>
                                    독일은 다양한 기회가 있는 매력적인 나라입니다. 하지만 새로운 환경에서 구직활동을 하는 것은 쉽지 않은 일입니다.<br/>
                                    저희 지쿠소프트는 이러한 어려움을 이해하고, 한국인 구직자들이 독일에서 성공적으로 자리잡을 수 있도록 최선을 다하고 있습니다.<br/>
                                    <br/>
                                    저희 사이트는 사용자 친화적인 인터페이스를 통해 구직자와 기업이 쉽게 소통할 수 있도록 설계되었습니다.<br/>
                                    또한, 다양한 직종과 산업 분야의 일자리를 한 곳에서 찾아볼 수 있으며, 한국어로 제공되는 정보로 더욱 편리하게 이용하실 수 있습니다.<br/>
                                    <br/>
                                    우리의 목표는 단순히 일자리를 소개하는 것을 넘어, 사람과 사람 사이의 소중한 연결을 만드는 것입니다.<br/>
                                    우리는 여러분의 경력과 꿈을 존중하며, 그에 맞는 최적의 기회를 제공하기 위해 항상 노력할 것입니다.<br/>
                                    <br/>
                                    함께 더 나은 미래를 만들어 나가길 기대합니다.<br/>
                                    <br/>
                                    지쿠소프트
                                </p>
                            </div>
                            {/* <div class="card-body">
                                <p class="card-text" style={{fontWeight: 'bold', marginTop: '10px'}}>회사정보</p>
                                <p class="card-text">
                                    <ul class="list-inline">
                                        <li class="list-inline-item me-4">
                                            <a target="_blank">상호명: 지쿠</a><br/>
                                            <a target="_blank">대표자: 조상훈</a><br/>
                                            <a target="_blank">사업장: 대구광역시 남구 양지로 16, 조영호내과 3층</a><br/>
                                            <a target="_blank">개인정보보호책임자: 조상훈</a>
                                        </li>
                                    </ul>
                                </p>
                            </div> */}
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
}